<template>
  <b-alert class="mt-3" variant="danger" show>
    <div class="alert-heading h4">{{ $t('commonKeys.error') }}</div>
    <p class="mb-0">{{ error.response.data.message }}</p>
  </b-alert>
</template>

<script>
  export default {
    name: 'ErrorBadge',
    props: {
      error: Error,
    },
    methods: {

    },
  };
</script>
